// widgetSelect.js
import React from 'react';
import { SelectPicker } from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css';
import '../css/widget/widget.select.css'

class WidgetSelect extends React.Component
{ 
    constructor(props)
    
    {
        super(props);
        this.state = {
            value : props.defaultValue!==undefined ? props.defaultValue : null,
            data  : props.data,
         options  : props.options!==undefined ? props.options : {}
        }

        this.onSelect = this.onSelect.bind(this);
        this.onClean = this.onClean.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    
    /**
     * 选中内容
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    onSelect(value, item, event)
    {
        this.setState({"value":value});

        if( this.props.onSelect!==undefined )
        {
            this.props.onSelect(value, item, event);
        }
    }
    
    /**
     * 清除选中内容
     */
    onClean()
    {
        this.setState({ value: null});

        if( this.props.onSelect!==undefined )
        {
            this.props.onSelect(null);
        }
    }

    /** 
     * 点击控制之外关闭控件  
     */
    onClose()
    {
        let itemData;

        const { value } = this.state;

        const { data } = this.props;

        for(let item of data )
        {
            if( value===item.value )
            {
                itemData = item;
            }
        }

        if( this.props.onSelect!==undefined )
        {
            this.props.onSelect(value, itemData);
        }
    }

    componentWillReceiveProps( nextProps )
    {
        const { value } = this.state;

        if( nextProps.defaultValue!==value )
        {
            if( nextProps.defaultValue!==undefined )
            {
                this.setState({value:nextProps.defaultValue});
            }
            else
            {
                this.setState({value:""});
            }
        }
    }

    render()
    {
        let { value } = this.state;
        
        const { data,Select } = this.props;

        const { title, cleanable, searchable} = this.state.options;

        let  placeholder = "请选择" + ( title!==undefined ? title : "" );

        return (
            <div className={Select?"widget-select widget-type":"widget-select"} >
                <SelectPicker data={data} value={value} searchable={searchable} placeholder={placeholder} cleanable={cleanable}
                    onSelect={this.onSelect} 
                    // onClose={this.onClose}
                     onClean={this.onClean}
                    menuClassName={"widget-select"} />
            </div>
        ) 
    }
}

export default WidgetSelect
